import script from "./AlbumCollaborators.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumCollaborators.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumCollaborators.vue?vue&type=style&index=0&id=4048c41c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4048c41c"]])

export default __exports__